import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const appName = localStorage.getItem('appName');
const routes: Routes = [
  { path: '', redirectTo: 'home/' + appName, pathMatch: 'full' },
  { path: 'home/:app', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
  { path: 'home/:app/entity-group/:group', loadChildren: () =>
  import('./pages/entity-list/entity-list.module').then(m => m.EntityListModule) },
  { path: 'home/:app/entity-group/:group/:id', loadChildren: () =>
  import('./pages/entity-exhibit/entity-exhibit.module').then(m => m.EntityExhibitModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
